import React from 'react';
import { FormHelperText } from '../FormHelperText';
import { useSpacing } from '../../api/spacing/useSpacing';
import { FormLabel } from '../FormLabel';
import { formGroupPropTypes } from './FormGroup.types';
import { StyledFieldset } from './FormGroup.styles';
export const FormGroup = React.forwardRef(({ 'data-testid': testId, children, className, disabled, hint, id, invalid = false, label, required, validationMessage, ...restProps }, ref) => {
    const hintMessageId = `${id}__hint-message`;
    const errorMessageId = `${id}__error-message`;
    const describedBy = [hint ? hintMessageId : '', invalid ? errorMessageId : '']
        .join(' ')
        .trim() || undefined;
    return (React.createElement(StyledFieldset, { "aria-describedby": describedBy, className: className, "data-testid": testId, disabled: disabled, id: id, outerSpacing: useSpacing(restProps), ref: ref },
        label && (React.createElement(FormLabel, { as: "legend", spaceStackEnd: 's', required: required, invalid: invalid, disabled: disabled }, label)),
        children,
        hint && (React.createElement(FormHelperText, { id: hintMessageId, spaceStackStart: 's', variant: "hint" }, hint)),
        invalid && (React.createElement(FormHelperText, { id: errorMessageId, spaceStackStart: hint ? 'xxs' : 's', variant: "invalid" }, validationMessage))));
});
FormGroup.propTypes = formGroupPropTypes;
FormGroup.displayName = 'FormGroup';
//# sourceMappingURL=FormGroup.js.map